export default {
  init() {

  },
  finalize() {
    const $alert = $('.global-alert');

    if ($alert.length > 0) {
      $alert.find('.global-alert-close').on('click', function() {
        $alert.addClass('hide');

        // Set a cookie for 24 hours
        const d = new Date();
        d.setTime(d.getTime() + 24 * 60 * 60 * 1000);

        document.cookie = `close_alert=1; expires=${d.toUTCString()}; path=/`;
      });
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/other/alert.js